import { render, staticRenderFns } from "./VarFormModal.vue?vue&type=template&id=f99ffc0e"
import script from "./VarFormModal.vue?vue&type=script&lang=js"
export * from "./VarFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f99ffc0e')) {
      api.createRecord('f99ffc0e', component.options)
    } else {
      api.reload('f99ffc0e', component.options)
    }
    module.hot.accept("./VarFormModal.vue?vue&type=template&id=f99ffc0e", function () {
      api.rerender('f99ffc0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/FormStory/Modals/VarFormModal.vue"
export default component.exports